export default __webpack_public_path__ + "static/RootSans-13Ultra-47a228906a0d0e5493caed0222e9b966.woff2";